import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, ArrowRight, Check } from "lucide-react";
import { Logo } from "@/components/Logo";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COLS = [
  { title: "Men", links: [["Denim", "/men-denim"], ["Graphic Tees", "/men-tees"], ["Basic Tees", "/men-basic-tees"], ["Shirts", "/men-shirts"], ["Hoodies & Sweatshirts", "/men-fleece"]] },
  { title: "Women", links: [["Denim", "/women-denim"], ["Graphic Tees", "/women-tees"], ["Dresses", "/women-dresses"], ["Hoodies & Sweatshirts", "/women-fleece"]] },
  { title: "The Brand", links: [["New Originals", "/new-originals"], ["About Us", "/about"], ["Wholesale", "/wholesale"]] },
];

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      toast.success("You're in. Welcome to AR / American Rag.");
      setEmail("");
    } catch { toast.error("Please enter a valid email."); }
  };
  return (
    <div className="border-t border-white/10 pt-10 mt-2">
      <div className="grid lg:grid-cols-2 gap-6 items-center">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-denim-accent mb-2">Stay in the know</p>
          <h3 className="font-display text-2xl font-bold uppercase tracking-tight">Join the AR / American Rag list</h3>
        </div>
        <form onSubmit={submit} className="w-full">
          <div className="flex items-center border-b border-white/30 focus-within:border-white transition-colors">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-input" placeholder="Enter your email" className="flex-1 bg-transparent py-3 text-base placeholder:text-white/40 outline-none" />
            <button data-testid="newsletter-submit" className="p-3 hover:text-denim-accent transition-colors" aria-label="Subscribe">{done ? <Check className="w-5 h-5" /> : <ArrowRight className="w-5 h-5" />}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 lg:py-20">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6">
        <div className="col-span-2">
          <Logo className="text-xl" dark />
          <p className="mt-5 text-sm text-white/50 max-w-xs leading-relaxed">
            AR / American Rag — a contemporary American fashion brand with a strong denim heritage. Confident, timeless, effortlessly cool.
          </p>
          <div className="flex items-center gap-4 mt-6">
            {[Instagram, Twitter, Facebook].map((Icon, i) => (
              <a key={i} href="#" aria-label="social" className="w-9 h-9 border border-white/15 flex items-center justify-center hover:bg-white hover:text-ink transition-colors"><Icon className="w-4 h-4" /></a>
            ))}
          </div>
        </div>
        {COLS.map((col) => (
          <div key={col.title}>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-5">{col.title}</h4>
            <ul className="space-y-3">
              {col.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-white/70 hover:text-white transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <NewsletterSignup />
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-white/40 font-mono uppercase tracking-wider">
        <span>© {new Date().getFullYear()} AR / American Rag. All rights reserved.</span>
        <div className="flex gap-6"><a href="#" className="hover:text-white">Privacy</a><a href="#" className="hover:text-white">Terms</a><a href="#" className="hover:text-white">Accessibility</a></div>
      </div>
    </div>
  </footer>
);
